import { MojisLines } from "../moji/MojisLines";
import { Params, ITimeline } from '../data/Params';
import { MojisDotRender } from "../moji/MojisDotRender";
import { LogoMark } from '../moji/logo/LogoMark';
import { DataManager } from "../data/DataManager";
import { DomControl } from './DomControl';

export class Timeline implements ITimeline{

    private lines:MojisLines;
    private counter:number = 0;
    private blinkRatio:number=0;
    private dotNum:number=0;//0,1,2,3
    private lineModeIndex:number=0;
    private dotRenderer:MojisDotRender;
    private logoMark:LogoMark;
    private dataManager:DataManager;
    private domControl:DomControl;
    private intervalId:number=0;

    public start(){

        this.dataManager = DataManager.getInstance();
        this.dotRenderer = MojisDotRender.getInstance();
        this.lines = this.dataManager.mojis;
        this.logoMark = this.dataManager.logoMark;
        this.domControl = this.dataManager.dom;
        this.blinkRatio=0;
        this.lineModeIndex = 0;//Math.floor( Math.random()*Params.LINE_MODES.length);
        Params.line_mode = Params.LINE_MODES[this.lineModeIndex];
        this.domControl.showTagline();
        this.startIntro();

    }

    private startIntro(){
        
       this.lines.setAllEnabled(false);
        
       setTimeout(()=>{
            this.domControl.hideTagline(0);//タグライン非表示
            this.logoMark.showFillLogo();//フィルロゴ表示
        },2000);

        setTimeout(()=>{
            Params.line_mode = Params.LINE_MODES[this.lineModeIndex];
        },3000)        
        
        setTimeout(()=>{
            this.logoMark.hideLogo(()=>{
                this.startInterval();
            });
        },4000)

    }


    private startInterval(){

        this.counter=0;
        this.dotNum=0;
        this.blinkRatio=0;
        Params.line_mode = Params.LINE_MODES[this.lineModeIndex];
        window.clearInterval(this.intervalId);

        this.countUp();
        this.intervalId=window.setInterval(()=>{
            if(this.lineModeIndex>=1)this.domControl.showTagline();
            else this.domControl.hideTagline(0);

            this.countUp();
        },1000);

    }

    //どうにかしていく

    private countUp(){

        if(!this.dataManager.isFocus)return;

        this.lines.boost();
        this.logoMark.boost();

        if(this.counter%4==0){

            let isLast:boolean=false;

            switch(this.dotNum){
                case 0:
                    this.blinkRatio=1;
                    Params.dot_speed=Params.DOT_SPEED_LOW;                    
                    break;

                case 1:
                    this.blinkRatio=0.5;
                    this.lines.changeNum(0,0);//数を変える
                    Params.dot_speed=Params.DOT_SPEED_LOW;
                    break;
                case 2:
                    this.blinkRatio=0.5;
                    this.lines.changeNum(1,0);
                    Params.dot_speed=Params.DOT_SPEED_LOW*1;
                    break;
                case 3:
                    this.blinkRatio=0.5;
                    this.lines.changeNum(2,1);
                    Params.dot_speed=Params.DOT_SPEED_LOW*1;
                    break;
                case 4:
                    this.blinkRatio=0.5;                    
                    this.lines.changeNum(3,2);
                    Params.dot_speed=Params.DOT_SPEED_LOW*1.5;
                    break;
                case 5:
                    //console.log(this.lineModeIndex,Params.LINE_MODE_MULTI);              
                    this.blinkRatio=0.6;
                    if(this.lineModeIndex==Params.LINE_MODE_MULTI){
                        this.lines.changeNum(2,3);
                    }else{
                        this.lines.changeNum(4,3);//最大４
                    }  
                    Params.dot_speed=Params.DOT_SPEED_LOW*2;
                    break;
                case 6:
                    //window.clearInterval(this.intervalId);
                    this.blinkRatio=0.3;                    
                    this.showLogo();
                    break;

                case 7:
                    
                    this.blinkRatio=0.5;                                    
                    break;

                case 8:
                    this.blinkRatio=0.5;                    

                    break;
                case 9:
                    this.blinkRatio=1;                    

                    this.hideLogo();
                    this.resetCount();
                    break;
            }
            
            this.dotRenderer.show();
            this.dotNum++;
        }

        //4回に一回モードが切り替わる
        //2回に一回

        if(this.counter%2==0){
            //this.domControl.setCopy();
            this.domControl.showScroll();
            this.lines.blinkBg( this.blinkRatio );
        }

        this.counter++;
    }


    private showLogo(){

        this.domControl.hideTagline(0.5);//タグライン非表示
        this.logoMark.showDotLogo(()=>{});//ロゴ表示

    }

    private hideLogo(){

        this.logoMark.hideLogo(()=>{});

    }

    private resetCount(){
        this.lineModeIndex++;
        this.lineModeIndex=this.lineModeIndex%Params.LINE_MODES.length;          
        this.counter=0;
        this.dotNum=0;
        Params.line_mode = Params.LINE_MODES[this.lineModeIndex];

        //この後を考える！！

        //6秒後最初に戻る
        /*
        setTimeout(()=>{
            this.lineModeIndex++;
            this.lineModeIndex=this.lineModeIndex%Params.LINE_MODES.length;    
            this.startIntro();
        },6000);*/

    }
    

}